import { render, staticRenderFns } from "./WordAudio.vue?vue&type=template&id=65f7a5f8&scoped=true&"
import script from "./WordAudio.vue?vue&type=script&lang=js&"
export * from "./WordAudio.vue?vue&type=script&lang=js&"
import style0 from "./WordAudio.vue?vue&type=style&index=0&id=65f7a5f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7a5f8",
  null
  
)

export default component.exports